import { articles } from "./guides"
import { trendArticles } from "./trend-articles"
import { reviewed } from "./study-skills"

export interface ArticleMetadata {
  url: string
  title: string
  description: string
  image: string
  group: string
  reviewed?: string
  published?: string
  modified?: string
  author?: { name: string; url: string; type: "Organization" | "Person" }
}
// Only confirmed editorial events belong here, never a build or feed refresh date.
const dates: {
  [url: string]: { published?: string; modified?: string; reviewed?: string }
} = require("./article-dates.json")
export const articleMetadata: { [url: string]: ArticleMetadata } = {}
articles.forEach(article => {
  articleMetadata[article.url] = {
    ...article,
    ...(article.group === "Study skills" ? { reviewed } : {}),
    ...dates[article.url],
  }
})
trendArticles.forEach(article => {
  const url = `/trends/${article.slug}/`
  articleMetadata[url] = {
    ...article,
    url,
    group: "Learning resources",
    ...dates[url],
  }
})
export const normaliseArticlePath = (pathname: string) =>
  pathname === "/" ? "/" : `${pathname.replace(/\/+$/, "")}/`
export const breadcrumbsFor = (article: ArticleMetadata) => {
  const hub =
    article.group === "Study skills" && article.url !== "/study-skills/"
      ? { name: "Study skills", url: "/study-skills/" }
      : article.group === "Learning resources"
      ? { name: "Learning resources", url: "/trends/" }
      : { name: "Guides", url: "/guides/" }
  return [
    { name: "Home", url: "/" },
    hub,
    { name: article.title, url: article.url },
  ]
}

// Attribution confirmed by the project owner on 29 September 2026.
Object.values(articleMetadata).forEach(article => {
  article.author = {
    name: "schoolcalendar.me",
    url: "/about/",
    type: "Organization",
  }
})
